export const Pages = {
  ROOT: "/",
  TESTS: "/tests"
};